import React, { useState } from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from '@chakra-ui/react';
import { Helmet } from 'react-helmet-async';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import StudentsPresentationFeature from '../components/features/StudentsPresentationFeature';

const FeaturesPage = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box>
      <Helmet>
        <title>Features | Build Your Skills | Ojasa Mirai</title>
        <meta
          name="description"
          content="Learn how our structured approach helps you build, explain, and improve your skills through presentations, code verification, and more."
        />
      </Helmet>

      <Navbar />

      {/* Hero Section */}
      <Box bg="linear-gradient(135deg, #6952d7 0%, #4c3a8d 100%)" py={16} color="white">
        <Container maxW="container.lg">
          <VStack spacing={6} textAlign="center">
            <Heading as="h1" size="2xl" fontWeight="bold">
              How You'll Learn & Grow
            </Heading>
            <Text fontSize="lg" maxW="2xl" opacity={0.95}>
              We believe in learning through doing. Here's how we help you build real skills,
              explain your thinking, and continuously improve.
            </Text>
          </VStack>
        </Container>
      </Box>

      {/* Features Tabs */}
      <Box py={16} bg="white">
        <Container maxW="container.lg">
          <Tabs
            index={activeTab}
            onChange={setActiveTab}
            variant="soft-rounded"
            colorScheme="purple"
          >
            <TabList mb={8} flexWrap="wrap" gap={3}>
              <Tab
                _selected={{ bg: 'accent.blue', color: 'white' }}
                _hover={{ bg: 'brand.200' }}
                fontSize="md"
                fontWeight="600"
              >
                Students Presentation
              </Tab>
              <Tab
                _selected={{ bg: 'accent.blue', color: 'white' }}
                _hover={{ bg: 'brand.200' }}
                fontSize="md"
                fontWeight="600"
                opacity={0.6}
              >
                Code Verification (Coming)
              </Tab>
              <Tab
                _selected={{ bg: 'accent.blue', color: 'white' }}
                _hover={{ bg: 'brand.200' }}
                fontSize="md"
                fontWeight="600"
                opacity={0.6}
              >
                Tests (Coming)
              </Tab>
            </TabList>

            <TabPanels>
              <TabPanel>
                <StudentsPresentationFeature />
              </TabPanel>
              <TabPanel>
                <Box py={16} textAlign="center">
                  <Heading color="gray.600" mb={4}>
                    Coming Soon
                  </Heading>
                  <Text color="gray.500">
                    Learn how we verify and validate your code quality.
                  </Text>
                </Box>
              </TabPanel>
              <TabPanel>
                <Box py={16} textAlign="center">
                  <Heading color="gray.600" mb={4}>
                    Coming Soon
                  </Heading>
                  <Text color="gray.500">
                    Discover how automated tests ensure your solutions work correctly.
                  </Text>
                </Box>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Container>
      </Box>

      <Footer />
    </Box>
  );
};

export default FeaturesPage;
